import React, { useState } from "react";
import FormPage from "../Component/FormPage";
import { useDispatch, useSelector } from "react-redux";
import { setUserEmail } from "../features/userSlice";
import { useNavigate } from "react-router-dom";

const FormPageContainer = () => {

    const count = useSelector ((state) => state.counter.value)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        password: "",
        name: "",
        gender: "",
        hobby: []
    })

    // const [email, setEmail] = useState("");
    // const [password, setPassword] = useState("");
    // const [name, setName] = useState("");
    // const [gender, setGender] = useState("");
    const [isPasswordError, setIsPasswordError] = useState(false);

    const handleChangeFormData = (ev) => {

        if(ev.target.name === "hobby") {
            setFormData({
                ...formData,
                [ev.target.name]: [...formData.hobby, ev.target.value]
            })
            return;
        }

        if (ev.target.name === "password") {
            if (ev.target.value.length < 5) {
                setIsPasswordError(true)
            } else {
                setIsPasswordError(false)
            }
        }

        setFormData({
            ...formData,
            [ev.target.name]: ev.target.value
        })
    }

    // const handleChange = (ev) => {
    //     if(ev.target.name === "email") {
    //         setEmail(ev.target.value)
    //     }
    //     if (ev.target.name === "name") {
    //         setName(ev.target.value);
    //     }
    //     if(ev.target.name === "gender") {
    //         setGender(ev.target.value)
    //     }
    //     if (ev.target.name === "password") {
    //         if (ev.target.value.length < 5) {
    //             setIsPasswordError(true)
    //         } else {
    //             setIsPasswordError(false)
    //         }
    //         setPassword(ev.target.value)
    //     }
    // }

    const handleSubmit = (ev) => {
        const form  = ev.currentTarget;
        if (form.checkValidity() === false) {
            ev.preventDefault();
            ev.stopPropagation();
        }
        alert(formData.name + "\n" + formData.email + "\n" + formData.password + "\n" + formData.gender + "\n" + formData.hobby)
        dispatch(setUserEmail(formData.email))
        navigate("/");
        resetData();
        ev.preventDefault();
    }

    const resetData = () => {
        setFormData(formData);
        setIsPasswordError("");
      }

    return(
        <FormPage email={formData.email}
                name={formData.name}
                count={count}
                password={formData.password}
                isPasswordError={isPasswordError}
                handleSubmit={handleSubmit}
                handleChange={handleChangeFormData}/>
    )
}

export default FormPageContainer;
